import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import { forwardRef, useEffect, useRef, useState } from "react";
import { TIME, DATETIME } from "../../../constants/time";
import { convertTimeToHHMMFormat } from "../../../helpers/datetimeHelpers";
import { HEADER_INDEX } from "../../../constants/app-constants";
const DropdownSelectTime = forwardRef(({ commonProps, onChange, id, onHide, value }, ref) => {

  const [timeDateState, setTimeDateState] = useState(value);
  const openDropdown = useRef(null);
  const inputRef = useRef(null);
  const defaultStartTime = new Date();
  defaultStartTime.setHours(0, 0, 0, 0);

  const defaultEndTime = new Date(defaultStartTime);
  defaultEndTime.setHours(23, commonProps?.stepMinute, 0, 0);

  useEffect(() => { setTimeDateState(value); }, [value]);

  const onTimeUpdate = (isUp, isMinute) => {
    let newTime = new Date(timeDateState);
    if (isUp) {
      if (isMinute) {
        newTime.setMinutes(newTime.getMinutes() + (commonProps?.stepMinute || 30));
      }
      else {
        newTime.setHours(newTime.getHours() + 1);
      }
      newTime = roundToValidMinute(newTime, commonProps?.stepMinute);
    } else {
      if (isMinute) {
        newTime.setMinutes(newTime.getMinutes() - (commonProps?.stepMinute || 30));
      }
      else {
        newTime.setHours(newTime.getHours() - 1);
      }
      newTime = roundToValidMinute(newTime, commonProps?.stepMinute);
    }
    var result = isMinute 
      ? new Date(timeDateState).setMinutes(newTime.getMinutes())
      : new Date(timeDateState).setHours(newTime.getHours());

    setTimeDateState(new Date(result));
    onChange(new Date(result));
  }

  const roundToValidMinute = (dateTime, stepMinute) => {
    const currentMinutes = dateTime.getMinutes();
    const step = stepMinute || 30;
    var timeDefault = new Date(DATETIME.MIN);
    var minuteDefault = timeDefault.getMinutes();
    let validMinute;
    if (minuteDefault !== currentMinutes && step !== currentMinutes) {
      let timeAdd = new Date(dateTime);
      let timeSub = new Date(dateTime);
      timeAdd = new Date(timeAdd.setMinutes(dateTime.getMinutes() + step));
      timeSub = new Date(timeSub.setMinutes(dateTime.getMinutes() - step));
      if (timeAdd.getMinutes() === minuteDefault) {
        validMinute = step;
      }

      if (timeSub.getMinutes() === step) {
        validMinute = minuteDefault
      }
    } else {
      validMinute = currentMinutes;
    }
    
    dateTime.setMinutes(validMinute, 0, 0);
    return dateTime;
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
    if (openDropdown.current) {
      openDropdown.current.toggle(e);
    }
  };

  const handleOverlayShow = () => {
    if (openDropdown.current) {
      const overlayElement = openDropdown.current.getElement();
      if (overlayElement) {
        const sidebar = document.querySelector(".p-sidebar-left");
        if (sidebar) {
          overlayElement.style.zIndex = `${HEADER_INDEX + 2}`;
        } else {
          overlayElement.style.zIndex = `${HEADER_INDEX - 1}`;
        }
      }
    }
  };

  const handleOverlayHide = () => {
    onHide();
  };

  const displayTime = () => {
    if (timeDateState) {
      return convertTimeToHHMMFormat(timeDateState);
    }
  }

  const showHoursAndMinutes = (isShowHour) => {
    if (timeDateState) {
      if (isShowHour) {
        return timeDateState.getHours().toString().padStart(2, '0');
      }
      else {
        return timeDateState.getMinutes().toString().padStart(2, '0');
      }
    }
    return "00";
  }

  return (
    <div className="relative">
      <div ref={inputRef} className="relative w-full flex dropdown-picker-time custom-dropdown-container">
        <InputText
          id={id+"-time-input"}
          className="keduall-typography text-16-semibold-600 keduall-form dropdown-input p-dropdown z-1 keduall-typography text-default-txt text-ellipsis custom-placeholder"
          type="text"
          value={displayTime()}
          onClick={(e) => handleInputClick(e)}
          readOnly
          placeholder={`${TIME.MIN}`}
        />
        <i className="pi cursor-pointer pi-angle-down keduall-form dropdown-input icon-angle-down-small absolute z-4 flex" onClick={handleInputClick}></i>
      </div>
      <OverlayPanel dismissable={true} onShow={handleOverlayShow} onHide={handleOverlayHide} ref={openDropdown} appendTo={() => inputRef.current} className="left-0 top-100 w-webkit-fill-available mt-2 ">
        <div className="p-dropdown-panel keduall-form dropdown-input p-datepicker p-datepicker-timeonly w-webkit-fill-available p-dropdown flex flex-column gap-075">
          {/* Time picker */}
          <div className="flex flex-row justify-content-center align-items-center gap-075 w-full mb-2">
            {/* panel */}
            <div className="w-full flex flex-row ">
              <div className="flex flex-column w-full p-hour-picker p-timepicker justify-content-center align-items-center">
                <div className="w-6 flex">
                  <Button
                    icon="pi pi-chevron-up"
                    className="p-button-text p-0 p-link shadow-none"
                    onClick={() => onTimeUpdate(true, false)}
                  />
                </div>
                <span className="w-6 flex justify-content-center py-1">
                  {showHoursAndMinutes(true)}
                </span>

                <div className="w-6 flex">
                  <Button
                    icon="pi pi-chevron-down"
                    className="p-button-text p-0 p-link shadow-none"
                    onClick={() => onTimeUpdate(false, false)}
                  />
                </div>
              </div>
              <div className="flex flex-column w-1 p-timepicker justify-content-center align-items-center">
                <span className="p-separator">:</span>
              </div>
              <div className="flex flex-column w-full p-minute-picker p-timepicker justify-content-center align-items-center">
                <div className="w-6 flex">
                  <Button
                    icon="pi pi-chevron-up"
                    className="p-button-text p-0 p-link shadow-none"
                    onClick={() => onTimeUpdate(true, true)}
                  />
                </div>
                <span className="w-6 flex justify-content-center py-1">
                  {showHoursAndMinutes(false)}
                </span>

                <div className="w-6 flex">
                  <Button
                    icon="pi pi-chevron-down"
                    className="p-button-text p-0 p-link shadow-none"
                    onClick={() => onTimeUpdate(false, true)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
});

export default DropdownSelectTime;
